import Vue from "vue";
import Router from "vue-router";
import { routes as auth } from "../modules/auth";
import { routes as home } from "../pages/home";
import { routes as attendance } from "../pages/panelAttendance";
import { routes as guiches } from "../pages/queues/guiches";
import { routes as registerQueues } from "../pages/queues/registerQueues";
import { routes as searchQueues } from "../pages/queues/searchQueues";
import { routes as report } from "../pages/report";
import { routes as registerServices } from "../pages/services/registerServices";
import { routes as searchServices } from "../pages/services/searchServices";
import beforeEach from "./beforeEach";

const routes: Array<any> = [
  ...auth,
  ...home,
  ...attendance,
  ...searchServices,
  ...registerServices,
  ...searchQueues,
  ...registerQueues,
  ...report,
  ...guiches
];

Vue.use(Router);

const router = new Router({ routes, mode: "history" });

router.beforeEach(beforeEach);

export default router;
